const Dashboard = () => import("./dashboard/views/Dashboard.vue");
import DevicesRoutes from "./devices/routes";
import SchedulerRoutes from "./scheduler/routes";
import WorkShiftRoutes from "./workshift/routes";
import ReportRoutes from "./reports/routes";
import OvertimeRoutes from "./overtime/routes";
import MobileClockLogs from "./mobileclocks/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "devices",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/devices/all",
    children: DevicesRoutes,
  },
  {
    path: "scheduler",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/scheduler/create",
    children: SchedulerRoutes,
  },
  {
    path: "workshift",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/workshift/all",
    children: WorkShiftRoutes,
  },
  {
    path: "reports",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/reports/generate",
    children: ReportRoutes,
  },
  {
    path: "overtime",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/overtime/all",
    children: OvertimeRoutes,
  },
  {
    path: "mobile-clocks",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/attendance/mobile-clocks/all-logs",
    children: MobileClockLogs,
  },
];
